import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { types as actions, removeTriggerAction } from '../../reducers/actions';
import { TriggerService } from '../../services';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.DELETE_TRIGGER),
    switchMap(action =>
      TriggerService.delete(action.trigger, store).pipe(
        map(() => removeTriggerAction(action.trigger)),
        catchError(retryAuthentication(action$, 'epics/triggers/deleteTrigger'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/triggers/deleteTrigger.js